import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [settings, setSettings] = useState(null);

  const loadMe = async () => {
    const token = localStorage.getItem("gm_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("gm_token");
      setUser(false);
    }
  };

  const loadPublicSettings = async () => {
    try {
      const { data } = await api.get("/settings/public");
      setSettings(data);
    } catch (e) {
      setSettings({ general: { app_name: "Glitch Manager" } });
    }
  };

  useEffect(() => {
    loadMe();
    loadPublicSettings();
  }, []);

  const login = (token, u) => {
    localStorage.setItem("gm_token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("gm_token");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, settings }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
